import { IconButton, theme } from '@alefeducation/ui-elements-library-core'
import { Filter } from '@alefeducation/ui-elements-library-icons'
import React, { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'
import ContentTypesFilter, { ContentTypeFiltersProps } from '../ContentTypesFilter'
import { SearchBar } from '../SearchBar/SearchBar'

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto 272px;
  .advance-filter-button {
    display: flex;
    justify-content: flex-end;
  }
  #search_input {
    border-radius: 8px 0px 0px 8px !important;
    border-right: none;
  }
`
const StyledIconButton = styled(IconButton)<{ active: boolean }>`
  border: 1px solid ${props => (props.active ? theme.colors.interactive['100'] : theme.colors.primary['40'])};
`

type SearchAndFilterProps = {
  searchValue: string
  onSearch: (value: string) => void
  advancedFilter?: {
    selected: number | string
    ontoggle: Dispatch<SetStateAction<boolean>>
    visible: boolean
  }
} & ContentTypeFiltersProps

const SearchAndFilter = (props: SearchAndFilterProps) => {
  const { searchValue, contentTypes, onSearch, onContentTypeChange } = props
  return (
    <Wrapper
      style={{
        gridTemplateColumns: 'auto 272px 48px'
      }}
    >
      <div
        style={{
          position: 'relative'
        }}
      >
        <SearchBar defaultValue={searchValue} onChange={onSearch} contentTypes={contentTypes} />
      </div>
      <ContentTypesFilter onContentTypeChange={onContentTypeChange} contentTypes={contentTypes} multiSelect={false} />
      <div className="advance-filter-button">
        <StyledIconButton
          data-testid="advance-filter-button"
          size="large"
          active={props.advancedFilter.visible}
          onClick={() => props.advancedFilter.ontoggle(prev => !prev)}
        >
          <Filter color={props.advancedFilter.visible ? theme.colors.interactive[100] : ''} fontSize={16} />
        </StyledIconButton>
      </div>
    </Wrapper>
  )
}

export default SearchAndFilter
